import React, { useState } from 'react';
import cn from 'classnames';
import style from "../common.module.scss"
import DangerIcon from '../../../shared/icons/DangerIcon';
import ScalesIcon from '../../../shared/icons/ScalesIcon';
import BoxIcon from '../../../shared/icons/BoxIcon';
import TemperatureIcon from '../../../shared/icons/TemperatureIcon';
import TransportTentIconNew from '../../../shared/icons/TransportTentIconNew';
import TransportCoveredIconNew from '../../../shared/icons/TransportCoveredIconNew';
import TransportIsothermIconNew from '../../../shared/icons/TransportIsothermIconNew';
import TransportRefrigeratorIconNew from '../../../shared/icons/TransportRefrigeratorIconNew';
import DocumentIconNew from '../../../shared/icons/DocumentIconNew';
import ConfectioneryIcon from '../../../shared/icons/ConfectioneryIcon';
import FurnitureIcon from '../../../shared/icons/FurnitureIcon';
import MetalIcon from '../../../shared/icons/MetalIcon';
import MetalCansIcon from '../../../shared/icons/MetalCansIcon';
import BeveragesIcon from '../../../shared/icons/BeveragesIcon';
import EquipmentIcon from '../../../shared/icons/EquipmentIcon';
import FoodIcon from '../../../shared/icons/FoodIcon';
import GlassProductsIcon from '../../../shared/icons/GlassProductsIcon';
import ConstructionMaterialsIcon from '../../../shared/icons/ConstructionMaterialsIcon';
import TobaccoIcon from '../../../shared/icons/TobaccoIcon';
import PharmaceuticalsIcon from '../../../shared/icons/PharmaceuticalsIcon';
import FertilizeIcon from '../../../shared/icons/FertilizeIcon';
import AlcoholIcon from '../../../shared/icons/AlcoholIcon';
import {t} from "i18next";

const OrdersInfoCargo = ({ item }) => {

    const renderVehicleIcon = (vehicleType) => {
        switch (vehicleType) {
            case 'awning':
                return <TransportTentIconNew width='24px' height='24px' />;
            case 'covered':
                return <TransportCoveredIconNew width='24px' height='24px' />;
            case 'isothermal':
                return <TransportIsothermIconNew width='24px' height='24px' />;
            case 'refrigerator':
                return <TransportRefrigeratorIconNew width='24px' height='24px' />;
            default:
                return <TransportTentIconNew width='24px' height='24px' />;
        }
    };

    const renderTemperatureIcon = (TemperatureType) => {
        switch (TemperatureType) {
            case '64f84458304b954cfda030c7':
                return <TemperatureIcon type={3} width='24px' height='24px' />;
            case '64f8444f304b954cfda030c6':
                return <TemperatureIcon type={3} width='24px' height='24px' />;
            case null:
                return <TemperatureIcon width='24px' height='24px' />;
            default:
                return <TemperatureIcon type={2} width='24px' height='24px' />;
        }
    };

    const renderCategoryIcon = (category) => {
        switch (category) {
            case 'paper':
                return <DocumentIconNew width='24px' height='24px' />;
            case 'confectionery':
                return <ConfectioneryIcon width='24px' height='24px' />;
            case 'furniture':
                return <FurnitureIcon width='24px' height='24px' />;
            case 'metal':
                return <MetalIcon width='24px' height='24px' />;
            case 'metal_cans':
                return <MetalCansIcon width='24px' height='24px' />;
            case 'beverages':
                return <BeveragesIcon width='24px' height='24px' />;
            case 'equipment':
                return <EquipmentIcon width='24px' height='24px' />;
            case 'food':
                return <FoodIcon width='24px' height='24px' />;
            case 'glassProducts':
                return <GlassProductsIcon width='24px' height='24px' />;
            case 'constructionMaterials':
                return <ConstructionMaterialsIcon width='24px' height='24px' />;
            case 'tobacco':
                return <TobaccoIcon width='24px' height='24px' />;
            case 'pharmaceuticals':
                return <PharmaceuticalsIcon width='24px' height='24px' />;
            case 'alcohol':
                return <AlcoholIcon width='24px' height='24px' />;
            case 'fertilize':
                return <FertilizeIcon width='24px' height='24px' />;
            default:
                return <DocumentIconNew width='24px' height='24px' />;
        }
    };

    return (
        <div className={cn(style.cargo_wrapper)}>
            <div className={cn(style.cargo_title, style.orders_title)}>{t('orderInfo.cargoInformation')}</div>
            <div className={style.cargo_content}>
                <div className={style.cargo_details}>
                    {renderCategoryIcon(item?.category)} {item?.categoryName}
                </div>
                <div className={style.cargo_details}>
                    {renderVehicleIcon(item?.vehicleType)} {item?.vehicleTypeName}
                </div>
                <div className={style.cargo_details}>
                    <ScalesIcon width='24px' height='24px' /> <div className={style.cargo_category}>{t('orderInfo.weight')}:</div> {item?.weight} {t('orderInfo.tons')}
                </div>
                <div className={style.cargo_details}>
                    {renderTemperatureIcon(item?.temperatureId)} {item?.temperatureName || 'Нет температурного режима'}
                </div>
                <div className={style.cargo_details}>
                    <BoxIcon width='24px' height='24px' /> <div className={style.cargo_category}>{t('orderInfo.size')}:</div> {item?.volume} {t('orderInfo.volume')}
                </div>
                <div className={style.cargo_details}>
                    <DangerIcon width='24px' height='24px' /> {item?.details}
                </div>
            </div>
        </div>
    );
};

export default OrdersInfoCargo;